import { render, staticRenderFns } from "./detailHandle.vue?vue&type=template&id=2776c18d&scoped=true&"
import script from "./detailHandle.vue?vue&type=script&lang=js&"
export * from "./detailHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2776c18d",
  null
  
)

export default component.exports